// Heat label translations per language
const HEAT_LABELS = {
  en: 'Heat',
  zh: '组',
  es: 'Serie',
  fr: 'Manche',
  de: 'Lauf'
};

/**
 * Get the translated heat label for the current language.
 * @param {number} heatNumber
 * @returns {string} e.g. "Heat 3", "组3", "Serie 3"
 */
export const getHeatLabel = (heatNumber) => {
  const lang = localStorage.getItem('dbpro_language') || 'en';
  const word = HEAT_LABELS[lang] || HEAT_LABELS.en;
  return `${word} ${heatNumber}`;
};

const STORAGE_KEY = 'dbpro_heat_counts';

/**
 * Read heat counter state from localStorage.
 * Resets automatically if the date has changed.
 */
const readState = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const state = JSON.parse(raw);
    const today = new Date().toISOString().slice(0, 10);
    if (state.date !== today) return null; // new day → reset
    return state;
  } catch {
    return null;
  }
};

/**
 * Increment the heat counter for a given target distance (in meters).
 * Called once when the user presses Start Session.
 * @param {number} targetDistanceMeters
 * @returns {number} the new heat number (1-based)
 */
export const incrementHeat = (targetDistanceMeters) => {
  const today = new Date().toISOString().slice(0, 10);
  const state = readState() || { date: today, counts: {} };
  state.date = today;
  const key = String(Math.round(targetDistanceMeters));
  const next = (state.counts[key] || 0) + 1;
  state.counts[key] = next;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  return next;
};

/**
 * Peek at the NEXT heat number without incrementing.
 * Used to show "Heat X" before the user presses Start.
 * @param {number} targetDistanceMeters
 * @returns {number}
 */
export const peekNextHeat = (targetDistanceMeters) => {
  const state = readState();
  if (!state) return 1;
  const key = String(Math.round(targetDistanceMeters));
  return (state.counts[key] || 0) + 1;
};
